module.exports = __webpack_public_path__ + "static/hill-82fe8368992406c2a2b9babf1ad13656.png";